import { render, staticRenderFns } from "./BasePdfViewer.vue?vue&type=template&id=089b1117&scoped=true"
import script from "./BasePdfViewer.vue?vue&type=script&lang=js"
export * from "./BasePdfViewer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "089b1117",
  null
  
)

export default component.exports